import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";

export const SectionCTA = ({ text = "רוצים לשמוע עוד?", buttonText = "דברו איתנו", href = "#contact" }) => (
  <div className="text-center mt-12 pt-8 border-t border-[#E5E0DA]">
    <p className="text-[#2C2C2C]/60 mb-4">{text}</p>
    <a href={href}>
      <Button variant="outline" className="rounded-full px-6 border-[#C4956A] text-[#C4956A] hover:bg-[#C4956A] hover:text-white transition-all">
        {buttonText}
        <ArrowLeft className="w-4 h-4 mr-2" />
      </Button>
    </a>
  </div>
);
